(function () {
    console.log('fab-dial loaded');
    window.__fabDialLoaded = true;
    window.__fabDialToggle = (sel) => {
        const d = sel ? document.querySelector(sel) : document.querySelector('.fab-dial');
        if (d) d.classList.toggle('is-open');
    };

    function closeAll() {
        document.querySelectorAll('.fab-dial.is-open').forEach(d => d.classList.remove('is-open'));
    }

    function bindToggle(btn) {
        // écouteur direct pour ne pas dépendre de la délégation seulement
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation(); // évite qu’un autre handler referme aussitôt
            const dial = btn.closest('.fab-dial');
            if (dial) dial.classList.toggle('is-open');
        });
    }

    // Lier tous les boutons au chargement
    document.querySelectorAll('[data-fab-toggle]').forEach(bindToggle);

    // Délégation (au cas où le bouton est ajouté dynamiquement + clic hors)
    document.addEventListener('click', (e) => {
        const t = e.target.closest('[data-fab-toggle]');
        if (t) return; // déjà géré par bindToggle
        if (!e.target.closest('.fab-dial')) closeAll();
    });

    // Escape pour fermer
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') closeAll();
    });
})();
